import { colors } from "../../../ui/colors";

export const flownectColors = {
  primary: colors.orange.base,
  primaryDark: colors.orange[200],
  primaryLight: "#e3f2fd",
  secondary: colors.yellow.base,
  gray: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
  },
};

export const jobStatusColors = {
  scheduled: {
    icon: "",
    color: "#1976d2",
    bg: "#e3f2fd",
    border: "#90caf9",
  },
  inProgress: {
    icon: "",
    color: "#ed6c02",
    bg: "#fff4e5",
    border: "#ffb74d",
  },
  completed: {
    icon: "",
    color: "#2e7d32",
    bg: "#e8f5e9",
    border: "#81c784",
  },
  cancelled: {
    icon: "",
    color: "#d32f2f",
    bg: "#ffebee",
    border: "#e57373",
  },
};

export const CALENDAR_VIEWS = {
  WEEK: "timeGridWeek",
  DAY: "timeGridDay",
  MONTH: "dayGridMonth",
  LIST: "listWeek",
};

export const CALENDAR_CONFIG = {
  slotMinTime: "00:00:00",
  slotMaxTime: "24:00:00",
  slotDuration: "02:00:00",
  contentHeight: "auto",
  dayMaxEvents: 100,
  eventMaxStack: 100,
};
